const esMessages = {
  "chat.end": "Reinicie su conversación de chat",
  "chat.endall": "Chat finalizado",
  "chat.cancel": "Cancelar",
  "chat.cookie":
    "Este asistente digital utiliza cookies para garantizar que obtenga la mejor experiencia",
  "chat.learn": "Aprende más",
  "chat.minimize": "Minimizar",
  "chat.hide": "Cerca",
  "chat.hidebot.text":
    "Cerrar hará que la avatar desaparezca durante 15 minutos.",
  "chat.hidebot": "Cerrar robot",
  "chat.restart": "Reiniciar",
  "switch.language": "Cambiar de idioma",
  "switch.property": "Cambiar propiedad",
  "restart.converstation": "Reiniciar conversación",
  "chat.endtext": "¿Está seguro de que desea finalizar el chat actual?",
  "check.availabity": "Consultar disponibilidad",
  "check.availabity.submit": "Enviar",
  "check.availabity.cancel": "Cancelar",
  "check.availabity.adults": "Adultas ",
  "check.availabity.children": "Niñas",
  "check.availabity.child.age": "Edad - niña",
  "feedback.leave": "Deja un comentario",
  "feedback.leave.message": "Deja un mensaje",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Enviar un caso",
  "caseform.system": "Sistema",
  "caseform.loading.systems": "Cargando sistemas...",
  "caseform.select.system": "Seleccionar sistema",
  "caseform.error.systems": "Error al cargar sistemas",
  "caseform.scenario": "Escenario",
  "caseform.loading.scenarios": "Cargando escenarios...",
  "caseform.select.scenario": "Seleccionar escenario",
  "caseform.error.scenarios": "Error al cargar escenarios",
  "caseform.topic": "Tema",
  "caseform.loading.topics": "Cargando temas...",
  "caseform.select.topic": "Seleccionar tema",
  "caseform.error.topics": "Error al cargar temas",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Asunto",
  "caseform.description": "Descripción",
  "caseform.attachments": "Archivos adjuntos",
  "caseform.attachments.remove": "Eliminar",
  "caseform.submit": "Enviar",
  "caseform.cancel": "Cancelar",
  "caseform.success.title": "Caso creado",
  "caseform.success.message": "Su caso ha sido creado exitosamente.",
  "caseform.success.caseNumber": "Número de caso:",
  "caseform.success.transferToLiveAgent":
    "Se le está transfiriendo a un agente en vivo.",
  "caseform.success.newChatWindowRightSide":
    "Se abrirá una nueva ventana de chat en el lado derecho de su navegador.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Elija una acción",
  "simpleaction.body":
    "Por favor seleccione una de las siguientes opciones:{br}{b}Crear un caso{/b} para enviar una solicitud de soporte, o {b}Iniciar un chat{/b} para conectarse con un agente ahora.",
  "simpleaction.startchat": "Iniciar un chat",
  "simpleaction.createcase": "Crear un caso",
  "caseform.error.generic": "Error en la creación del caso.",
  "caseform.error.generic.message":
    "Ocurrió un error al crear su caso. Por favor, inténtelo de nuevo más tarde.",
};
export default esMessages;
